import { createAction } from '@reduxjs/toolkit';
export const CREATE_ANALYTIC_TEAM = 'CREATE_ANALYTIC_TEAM';
export const createAnalyticTeamAction = createAction(CREATE_ANALYTIC_TEAM);